var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAspasUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 32,
    viewBox: "0 0 39 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3499 8C16.3499 12.4183 12.7682 16 8.34992 16C3.93164 16 0.349915 12.4183 0.349915 8C0.349915 3.58172 3.93164 0 8.34992 0C12.7682 0 16.3499 3.58172 16.3499 8Z",
    fill: "#F57F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34997 26.5C-0.650084 20 -0.316744 11.8333 0.349922 7.5L9.34996 15C9.18329 16.5 7.21745 19.0728 7.84991 23.5C8.34992 27 9.6833 28.3333 11.85 31.5C11.1833 30.8333 8.94023 30.3894 5.34997 26.5Z",
    fill: "#F57F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3499 8C38.3499 12.4183 34.7682 16 30.3499 16C25.9316 16 22.3499 12.4183 22.3499 8C22.3499 3.58172 25.9316 0 30.3499 0C34.7682 0 38.3499 3.58172 38.3499 8Z",
    fill: "#F57F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.35 26.5C21.3499 20 21.6833 11.8333 22.3499 7.5L31.35 15C31.1833 16.5 29.2174 19.0728 29.8499 23.5C30.3499 27 31.6833 28.3333 33.85 31.5C33.1833 30.8333 30.9402 30.3894 27.35 26.5Z",
    fill: "#F57F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAspasUp);
export default __webpack_public_path__ + "static/media/aspasUp.18151e3913f2f82b041b08c289157709.svg";
export { ForwardRef as ReactComponent };